import React, { Component } from 'react';

import { Form } from 'react-bootstrap';

import * as util from '../../library/utilitys';
class CommonRadio extends Component{

    render = () => {

        let props = this.props;

        let { type, id, label, value, validator, error } = props?.input;
        
        let radio = props?.radio || {};

        let { element, callback , disabled = false, hr = false, size="md" } = this.props;

        let isInline = element === 'Searchs' ? true : radio?.display === "inline";

        return (
            <>
                {element === 'Inputs' && (
                    <div className="mb-0">
                        <Form.Group>
                            <Form.Label className={`d-block ${size === 'sm' ? 'label-size-sm' : ''}`}>{label} {validator.required && (<>*</>)}</Form.Label>
                        </Form.Group>
                    </div>
                )}

                <Form.Group>
                    <div className={isInline ? "d-inline-flex gap-2" : "d-flex flex-column"}>
                        {radio.inputs?.map((item, index) => (
                                <Form.Check
                                    key={`${element}_${id}_${item.id}`}
                                    type="radio"
                                    id={`${element}_${id}_${item.id}`}
                                    name={`${element}_${id}`}
                                    label={item.label}
                                    value={item.value}
                                    checked={value === item.value}
                                    inline={isInline}
                                    onChange={(e) => callback(e , element)}
                                    disabled={disabled} 
                                    className={size === 'sm' ? 'radio-sm' : ''}
                                />
                        ))}
                    </div>

                    {(element === 'Inputs' && error?.status) && (
                        <div className="invalid-feedback d-block mt-2 ms-2" style={{ fontSize: "0.75rem" }}>
                            <i className="fa-classic fa-light fa-circle-exclamation fa-fw me-1" />
                            {error?.msg}
                        </div>
                    )}
                </Form.Group>

                {hr && <hr className="hr-custom" />}
            </>
        )
    }
}

export default CommonRadio;